import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";

import useCustom from "../customHook/customHook";
import { Modal } from "bootstrap";
import CreateMap from "./CreateMap";
import Captcha from "./Captcha";
import { isMobile } from "react-device-detect";

const constants = require("file-configs/constants");

export default function ReportPage(props) {
  const [globalState, setGlobalState] = useCustom();
  const inputFile = useRef(null);
  const [update_end, setUpdateEnd] = useState("");

  const [modal_alert_close, setModalAlertClose] = useState(null); //สำหรับ alert
  const modal_alert_ref = useRef(); //สำหรับ alert
  const [alert_header, setAlertHeader] = useState(); //หัวข้อ alert
  const [alert_content, setAlertContent] = useState(); //รายละเอียก alert
  const [alert_description, setAlertDescription] = useState(); //รายละเอียก alert
  const alert_success = (
    <span class="material-icons text-success post-alert-icon">
      check_circle
    </span>
  );
  const alert_fail = (
    <span class="material-icons text-danger post-alert-icon">cancel</span>
  );

  const [modal_loading_report_close, setModalLoadingReportClose] =
    useState(null);
  const modal_loading_ref = useRef();

  const [checkMobile, setCheckMobile] = useState(true);

  const [modal_fillOTP_close, setModalFillOTPClose] = useState(null);
  const modal_fillOTP_ref = useRef();

  const [reportAddress, setReportAddress] = useState();
  const [reportMap, setReportMap] = useState(null);

  const [showErrorText, setShowErrorText] = useState(false);

  const [nameSurname, setNameSurname] = useState("");
  const [phone, setPhone] = useState("");
  const [smsOTP, setSmsOTP] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [setotpbuttondisabled, setOTPButtonDisabled] = useState(false);
  const [disableBtnSendData, setDisableBtnSendData] = useState(false);
  const [contactEmail, setContactEmail] = useState("");
  const [reporterOrgName, setReporterOrgName] = useState("");
  const [detailReport, setDetailReport] = useState("");
  const [imgReport, setImgReport] = useState(constants.DEFAULT_POST_PHOTO);
  const [secret, setSecret] = useState("false"); // True or False
  const [sexReporter, setSexReporter] = useState(""); // ชาย or หญิง
  const [typeReporter, setTypeReporter] = useState("ประชาชน"); // ประชาชน or หน่วยงาน
  const [urgent, setUrgent] = useState(""); // ระดับความเร่งด่วน (ภายใน 30 / 14 / 7 / 3-5 วัน)
  const [postType, setPostType] = useState("เรื่องร้องทุกข์"); // ประเภทโพสการแจ้ง เรื่องร้องทุกข์ / สอบถามข้อมูล
  const [contactPhone, setContactPhone] = useState(""); // เบอร์เอาไว้โทรกลับไปคุยด้วย

  const [listProblemTypeAll, setListProblemTypeAll] = useState([]);

  const [listProblemTypeMain, setListProblemTypeMain] = useState([]);
  const [selectedProblemTypeMain, setSelectedProblemTypeMain] = useState("");

  const [listProblemTypeSecondary, setListProblemTypeSecondary] = useState([]);
  const [selectedProblemTypeSecondary, setSelectedProblemTypeSecondary] =
    useState("");

  useEffect(() => {
    setCheckMobile(false);
    getLocation();
    getProblemType();
    console.log("Version : ", constants.WEB_VERSION);
  }, []);

  useEffect(() => {
    if (checkMobile == false) {
      setCheckMobile(true);
      if (isMobile == true) {
        window.location.replace("https://landing.traffy.in.th?key=xEVHCVHQ");
      }
    }
  }, [checkMobile]);

  useEffect(() => {
    if (Object.keys(globalState.current_coors).length !== 0) {
      // getGeocode(globalState.current_coors);
      document.getElementById("location").style.display = "none";

      setReportMap(
        <div class="container-fluid">
          <div class="col-12 ">
            <CreateMap />
          </div>
        </div>
      );
    } else {
      document.getElementById("location").style.display = "block";
    }
  }, [globalState.current_coors]);

  useEffect(() => {
    // console.log(globalState.verifiedCaptcha);
  }, [globalState.verifiedCaptcha]);

  useEffect(() => {
    let state_arr = [];
    let id_arr = [];
    if (selectedProblemTypeMain.length != 0) {
      listProblemTypeAll.forEach(async (v) => {
        if (v["parent_id"] == selectedProblemTypeMain) {
          state_arr.push(<option value={v["id"]}>{v["name"]}</option>);
          id_arr.push(v["id"]);
        }
      });
      setListProblemTypeSecondary(state_arr);
      setSelectedProblemTypeSecondary(id_arr[0]);
    }
  }, [selectedProblemTypeMain]);

  useEffect(() => {
    if (update_end != undefined && update_end != "") {
      setAlert("แจ้งปัญหาสำเร็จ", alert_success, "");
      modalHide(modal_loading_report_close);
      modalHide(modal_fillOTP_close);
      setTimeout(() => {
        window.location.reload(false);
      }, 2500);
    }
  }, [update_end]);

  useEffect(() => {
    // console.log("ความลับ : ", secret);
  }, [secret]);

  useEffect(() => {
    // console.log("เพศ : ", sexReporter);
  }, [sexReporter]);

  useEffect(() => {
    // console.log("ประเภทคนแจ้ง : ", typeReporter);
  }, [typeReporter]);

  useEffect(() => {
    // console.log("ความเร่งด่วน : ", urgent);
  }, [urgent]);

  useEffect(() => {
    // console.log("ประเภทโพสแจ้ง : ", postType);
  }, [postType]);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      // console.log("Geolocation is not supported by this browser.")
    }
  };

  const showPosition = async (position) => {
    await setGlobalState({
      current_coors: {
        lng: position.coords.longitude,
        lat: position.coords.latitude,
      },
    });
  };

  const getGeocode = async (current_coors) => {
    let response = await fetch(
      constants.HOST_GOOGLE_MAP +
        "/geocode/json?latlng=" +
        current_coors.lat +
        "," +
        current_coors.lng +
        "&key=" +
        constants.GOOGLE_MAP_KEY +
        "&language=TH"
    );
    let data = await response.json();

    if (
      data !== undefined &&
      data !== null &&
      data.hasOwnProperty("results") &&
      data["results"].hasOwnProperty(0) &&
      data["results"][0].hasOwnProperty("formatted_address")
    ) {
      setReportAddress(data["results"][0]["formatted_address"]);
    } else {
      setReportAddress("");
    }
  };

  const getProblemType = async () => {
    let state_arr = [];
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
      },
    };

    let response = await fetch(
      "https://kong.traffy.in.th/bma1555-api-php/get_problemtype/",
      requestOptions
    );
    let data = await response.json();

    if (data["results"] != null) {
      setListProblemTypeAll(data["results"]);
      if (data["results"][0] != null) {
        setSelectedProblemTypeMain(data["results"][0].id);
      }

      await data["results"].forEach(async (v) => {
        if (v["id"] == v["parent_id"]) {
          state_arr.push(<option value={v["id"]}>{v["name"]}</option>);
        }
      });

      setListProblemTypeMain(state_arr);
    }
  };

  const onChangeProblemTypeMain = (e) => {
    setSelectedProblemTypeMain(e.target.value);
  };

  const onChangeProblemTypeSecondary = (e) => {
    setSelectedProblemTypeSecondary(e.target.value);
  };

  const handleBtnAlertClose = async () => {
    modalHide(modal_alert_close);
  };

  const handlefuncFillOTP = (e) => {
    if (globalState.current_coors.length == 0) {
      setAlert(
        "ไม่สำเร็จ",
        alert_fail,
        "กรุณาอนุญาตให้เข้าถึงตำแหน่งปัจจุบันเพื่อแจ้งปัญหา"
      );
    } else if (detailReport.length == 0) {
      setTimeout(() => {
        setAlert("ไม่สำเร็จ", alert_fail, "กรุณากรอกรายละเอียดการแจ้ง");
      }, 1000);
    } else if (nameSurname.length == 0) {
      setTimeout(() => {
        setAlert("ไม่สำเร็จ", alert_fail, "กรุณากรอกชื่อ-นามสกุล ผู้แจ้ง");
      }, 1000);
    } else if (phone.length == 0) {
      setTimeout(() => {
        setAlert("ไม่สำเร็จ", alert_fail, "กรุณากรอกเบอร์มือถือ");
      }, 1000);
    } else {
      requestOTP();

      setTimeout(() => {
        modalShow(modal_fillOTP_ref, setModalFillOTPClose);
      }, 500);
    }
  };

  const handleModalFillOTPClose = async () => {
    modalHide(modal_fillOTP_close);
  };

  const setAlert = async (header_text, icon, description) => {
    setAlertHeader(header_text);
    setAlertContent(icon);
    setAlertDescription(description);
    modalShow(modal_alert_ref, setModalAlertClose);
  };

  const modalShow = (mRef, setModals) => {
    const modal = new Modal(mRef.current, { keyboard: false });
    setModals(modal);
    modal.show();
  };

  const modalHide = (modal_hide) => {
    // console.log(modal_hide);
    modal_hide.hide();
  };

  const handleClickUploadImg = (event) => {
    inputFile.current.click();
  };

  const onChangePicture = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files[0]) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgReport(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
    // setImgReport(URL.createObjectURL(e.target.files[0]));
  };

  const requestOTP = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
      },
    };

    if (phone.length == 0) {
      setAlert("ไม่สำเร็จ", alert_fail, "กรุณากรอกเบอร์มือถือ");
    } else {
      let response = await fetch(
        "https://kong.traffy.in.th/bma1555-api-php/get_sms_otp/?contact_sms=" +
          phone,
        requestOptions
      );
      let data = await response.json();

      if (data.hasOwnProperty("message") && data["message"] == "") {
        setOTPButtonDisabled(true);
        setAlert(
          "ส่งรหัส OTP ไปที่เบอร์ " + phone + " แล้ว",
          alert_success,
          "สามารถดูรหัส OTP ได้จากข้อความ SMS"
        );
        setTimeout(() => {
          setOTPButtonDisabled(false);
        }, 12000);
      } else {
        setAlert(
          "ไม่สามารถส่งรหัส OTP ไปที่เบอร์ " + phone,
          alert_fail,
          data["message"]
        );
      }

      // console.log(data);
    }
  };

  const sendReportData = async (e) => {
    e.preventDefault();
    setDisableBtnSendData(true);

    let contact_name = nameSurname;
    let contact_sms = phone;
    let description = detailReport;
    // let address = reportAddress;
    // let address = globalState.address_from_google;
    let address = document.getElementById("searchAddressTextBox").value;
    let latitude = globalState.current_coors.lat;
    let longitude = globalState.current_coors.lng;
    let photo = imgReport;
    if (photo == "https://storage.googleapis.com/traffy_public_bucket/dashboard_icon/image_preview.png") {
      photo = constants.DEFAULT_POST_PHOTO_BASE64;
    }
    let contact_email = contactEmail;
    let reporter_type = typeReporter;
    let reporter_gender = sexReporter;
    let reporter_org = reporterOrgName;
    let post_type = postType;
    let contact_phone = contactPhone;

    let data_to_insert = JSON.stringify({
      contact_name: contact_name,
      contact_sms: contact_sms.replace("-", ""),
      photo_base64: photo,
      description: description,
      topic: selectedProblemTypeSecondary,
      latitude: latitude,
      longitude: longitude,
      address: address,
      contact_email: contact_email,
      otp_sms: smsOTP,
      reporter_type: reporter_type,
      reporter_gender,
      reporter_gender,
      urgent: urgent,
      secret: secret,
      post_type: post_type,
      contact_phone: contact_phone,
      reporter_org: reporter_org,
    });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
      },
      body: data_to_insert,
    };

    if (globalState.current_coors.length == 0) {
      setAlert(
        "ไม่สำเร็จ",
        alert_fail,
        "กรุณาอนุญาตให้เข้าถึงตำแหน่งปัจจุบันเพื่อแจ้งปัญหา"
      );
    } else {
      modalShow(modal_loading_ref, setModalLoadingReportClose);
      let response;

      try {
        response = await fetch(
          "https://kong.traffy.in.th/bma1555-api-php/new_post/",
          requestOptions
        );
      } catch (error) {
        console.log('There was an error', error);
      }
      
      // Uses the 'optional chaining' operator
      if (response?.ok) {
        let data = await response.json();

        console.log(data.status);

        if (data.status == "success") {
          setDisableBtnSendData(true);
          setTimeout(() => {
            setUpdateEnd(Date.now());
          }, 1500);
          window.scrollTo(0, 0);
        } else {
          setDisableBtnSendData(false);
          if (data.hasOwnProperty("message")) {
            if (data.message.indexOf('{') > -1 && data.message.indexOf('}') > -1) {
              let data_message_json = data.message.substring(data.message.indexOf('{'));
              data_message_json = JSON.parse(data_message_json);
              data.message = data.message.substring(0, data.message.indexOf('{')).trim();
              if (data_message_json.hasOwnProperty("message")) {
                data.message = data.message + ' | ' + data_message_json["message"];
              }
            }
            data.message = data.message.replaceAll(' | ', "\n");
            setAlert("ไม่สำเร็จ", alert_fail, data.message);
          }
          else {
            setAlert("ไม่สำเร็จ", alert_fail, "ไม่สามารถส่งข้อมูลได้");
          }
          setShowErrorText(true);
        }
      } else {
        setDisableBtnSendData(false);
        setAlert("ไม่สำเร็จ", alert_fail, "ไม่สามารถส่งข้อมูลได้");
        setShowErrorText(true);
      }

    }
  };

  const handleTypeReporter = (e) => {
    setTypeReporter(e.target.value);
  };

  const handleSexReporter = (e) => {
    setSexReporter(e.target.value);
  };

  const handleSecretReport = (e) => {
    setSecret(e.target.value);
  };

  const handlePostType = (e) => {
    setPostType(e.target.value);
  };

  const handleUrgent = (e) => {
    setUrgent(e.target.value);
  };

  return (
    <section id="report">
      <div class="container-fluid">
        <div class="row p-2 d-flex justify-content-center">
          <div class="col-sm-6 bg-white shadow-sm p-3 mb-5 bg-body rounded  ">
            <div className="d-flex justify-content-center">
              <img
                onClick={(event) => {
                  event.preventDefault();
                  window.open(
                    "https://landing.traffy.in.th?key=xEVHCVHQ",
                    "_blank"
                  );
                }}
                src={
                  "https://storage.googleapis.com/traffy_public_bucket/attachment/2022-12/1672114607928.jpeg"
                }
                className="img-icon-passwordPage d-grid  mx-3 mt-3 mb-3"
                height="100px"
              ></img>

              <img
                id="fondueLogo"
                onClick={(event) => {
                  event.preventDefault();
                  window.open("https://lin.ee/nwxfnHw", "_blank");
                }}
                src={
                  "https://www.traffy.in.th/wp-content/uploads/2021/05/Untitled-1-2-150x150.png"
                }
                className="img-icon-passwordPage d-grid  mx-3 mt-3 mb-3"
                height="100px"
              ></img>
            </div>
            <p class="h3 mt-3 text-center fw-bold ">
              รับแจ้งปัญหา ศูนย์กทม.1555
            </p>

            <form
              id="myform"
              class="needs-validation"
              novalidate
              onSubmit={sendReportData}
            >
              <div class="p-3 was-validated">
                <p class="h5 text-start fw-bold">
                  รายละเอียดการแจ้ง <h class="text-danger">*</h>
                </p>
                <textarea
                  required
                  class="form-control"
                  id="reportDetail"
                  value={detailReport}
                  onChange={(e) => setDetailReport(e.target.value)}
                  placeholder="กรุณาพิมพ์รายละเอียดที่ต้องการแจ้ง (งดเว้นข้อมูลส่วนบุคคล เช่น ชื่อ บ้านเลขที่ เบอร์โทร ฯลฯ)"
                  rows="3"
                ></textarea>
              </div>

              <div class="p-3">
                <p class="h5 text-start fw-bold mb-3">
                  เลือกประเภทปัญหาหลัก <h class="text-danger">*</h>
                </p>

                <select
                  className="form-select form-select-lg"
                  aria-label="problem-type"
                  onChange={onChangeProblemTypeMain}
                >
                  {listProblemTypeMain}
                </select>
              </div>

              <div class="p-3">
                <p class="h5 text-start fw-bold mb-3">
                  เลือกประเภทปัญหารอง <h class="text-danger">*</h>
                </p>

                <select
                  className="form-select form-select-lg"
                  aria-label="problem-type"
                  value={selectedProblemTypeSecondary}
                  onChange={onChangeProblemTypeSecondary}
                >
                  {listProblemTypeSecondary}
                </select>
              </div>

              <div class="p-3 was-validated">
                <p class="h5 text-start fw-bold mb-3">
                  ชื่อ-นามสกุล ผู้แจ้ง <h class="text-danger">*</h>
                </p>
                <input
                  required
                  type="text"
                  class="form-control"
                  value={nameSurname}
                  onChange={(e) => setNameSurname(e.target.value)}
                  placeholder="กรุณากรอกชื่อ-นามสกุล"
                />
              </div>

              <div class="p-3 was-validated">
                <p class="h5  fw-bold ">
                  เบอร์โทรศัพท์มือถือผู้แจ้ง (เพื่อรับรหัส OTP ทางข้อความ SMS)
                  <h class="text-danger">*</h>
                </p>
                <input
                  required
                  pattern="\d{10}"
                  type="tel"
                  data-bind="value:replyNumber"
                  class="form-control"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="เช่น 0812345678 (เบอร์เดียวเท่านั้น)"
                />
              </div>

              <div class="p-3">
                <p class="h5 text-start fw-bold mb-3">
                  ช่องทางให้เจ้าหน้าที่ติดต่อสอบถามเพิ่มเติม
                </p>
                <input
                  type="tel"
                  class="form-control"
                  value={contactPhone}
                  onChange={(e) => setContactPhone(e.target.value)}
                  placeholder="เบอร์มือถือ/บ้าน/ที่ทำงาน (ได้หลายเบอร์) ช่วงเวลาที่สะดวก ฯลฯ"
                />
                <small>
                  (หากไม่ต้องการให้ติดต่อกลับ ให้เว้นว่างไว้
                  แต่ปัญหาอาจถูกแก้ไขล่าช้า)
                </small>
              </div>

              <div class="p-3">
                <p class="h5 text-start fw-bold mb-3">อีเมลผู้แจ้ง (ถ้ามี)</p>
                <input
                  type="text"
                  class="form-control"
                  value={contactEmail}
                  onChange={(e) => setContactEmail(e.target.value)}
                  placeholder="เช่น abc@def.com (อีเมลเดียวเท่านั้น)"
                />
              </div>

              <div class="p-3 pb-0">
                <p class="h5 text-start fw-bold mb-3">
                  สถานที่เกิดปัญหา <h class="text-danger">* </h>
                  <h class="fw-bold underline-text">
                    (คลิกแผนที่เพื่อเลือกตำแหน่งที่ต้องการได้)
                  </h>
                </p>
                <p class="h6 fw-bold  mt-4 text-address-report">
                  {/* {reportAddress} */}
                  {globalState.address_from_google}
                </p>

                {/* ******** ส่วนของตัวเตือนเปิด Location ********** */}

                <div id="location">
                  <div class="text-left bg-danger text-white p-2 d-flex justify-content-center">
                    <span class="material-icons pe-2">error_outline</span>
                    กรุณาอนุญาตให้เข้าถึงตำแหน่งปัจจุบันเพื่อแจ้งปัญหา
                    <br />
                    <br />
                    - สำหรับ Android : แตะที่รูปกุญแจ บนแถบด้านบน
                    (อยู่ด้านซ้ายของเว็บไซต์ bkkrongtook.traffy.in.th) -&gt;
                    "การอนุญาต"/"Permissions" -&gt; เลื่อนเปิด
                    "ตำแหน่ง"/"Location" -&gt; Reload/Refresh หน้าเว็บอีกครั้ง
                    <br />
                    <br />
                    - สำหรับ iPhone/iPad : หากกดไม่อนุญาติไปแล้ว
                    ยังไม่มีวิธีปลดบล็อกตำแหน่ง
                    <br />
                    <br />- สำหรับ Windows : คลิกที่รูปกุญแจ บนแถบด้านบน
                    (อยู่ด้านซ้ายของเว็บไซต์ bkkrongtook.traffy.in.th) -&gt;
                    เลื่อนเปิด "ตำแหน่ง"/"Location" หรือเลือก "Allow" -&gt;
                    Reload/Refresh หน้าเว็บอีกครั้ง
                  </div>
                </div>
              </div>

              {reportMap}

              <div class="p-3">
                <p class="h5 text-start fw-bold mb-3">ประเภทเรื่องแจ้ง</p>

                <div class="radio" onChange={handlePostType}>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="postTypeRadio"
                      value={"เรื่องร้องทุกข์"}
                      checked={postType == "เรื่องร้องทุกข์" ? true : false}
                    />{" "}
                    เรื่องร้องทุกข์
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="postTypeRadio"
                      value={"สอบถามข้อมูล"}
                    />{" "}
                    สอบถามข้อมูล
                  </label>
                </div>
              </div>

              {/* <div class="p-3 mt-3">
                <p class="h5 text-start fw-bold mb-3">
                  เก็บโพสการแจ้งนี้เป็นความลับหรือไม่
                </p>

                <div class="radio" onChange={handleSecretReport}>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="keepSecretRadio"
                      value={"false"}
                      checked={secret == "false" ? true : false}
                    />{" "}
                    ไม่เป็นความลับ (ส่งต่อไป เพื่อนชัชชาติ และ เขต)
                    <span style={{ color: "red" }}>
                      <small>
                        *ห้ามกรอกข้อมูลส่วนตัว เช่น ชื่อ ที่อยู่ เบอร์โทร
                        ในช่องรายละเอียดการแจ้ง
                      </small>
                    </span>
                  </label>

                  <label class="radio-inline">
                    <input type="radio" name="keepSecretRadio" value={"true"} />{" "}
                    เป็นความลับ (ส่งต่อไป กรุงเทพโปร่งใส){" "}
                    <small>
                      เช่น เรื่องที่อาจเกิดการพิพาท หรือพาดพิงบุคคลอื่น
                    </small>
                  </label>
                </div>
              </div> */}

              <div class="p-3">
                <p class="h5 text-start fw-bold mb-3">เพศผู้แจ้ง</p>

                <div class="radio" onChange={handleSexReporter}>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="sexReporterRadio"
                      value={"ชาย"}
                      checked={sexReporter == "ชาย" ? true : false}
                    />{" "}
                    ชาย
                  </label>

                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="sexReporterRadio"
                      value={"หญิง"}
                    />{" "}
                    หญิง
                  </label>

                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="sexReporterRadio"
                      value={""}
                      checked={sexReporter == "" ? true : false}
                    />{" "}
                    (ไม่ระบุ)
                  </label>
                </div>
              </div>

              <div class="p-3">
                <p class="h5 text-start fw-bold mb-3">ประเภทผู้แจ้ง</p>

                <div class="radio" onChange={handleTypeReporter}>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="typeReporterRadio"
                      value={"ประชาชน"}
                      checked={typeReporter == "ประชาชน" ? true : false}
                    />{" "}
                    ประชาชน
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="typeReporterRadio"
                      value={"หน่วยงาน"}
                    />{" "}
                    หน่วยงาน
                  </label>
                </div>
              </div>

              {typeReporter == "หน่วยงาน" ? (
                <div class="p-3">
                  <p class="h5 text-start fw-bold mb-3">ชื่อหน่วยงาน</p>
                  <input
                    type="text"
                    class="form-control"
                    value={reporterOrgName}
                    onChange={(e) => setReporterOrgName(e.target.value)}
                    placeholder="กรอกชื่อหน่วยงาน ถ้ามี"
                  />
                </div>
              ) : null}

              <div class="p-3">
                <p class="h5 text-start fw-bold mb-3">ความเร่งด่วนของงาน</p>

                <div class="radio" onChange={handleUrgent}>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="urgentRadio"
                      value={"ภายใน 3-5 วัน"}
                      checked={urgent == "ภายใน 3-5 วัน" ? true : false}
                    />{" "}
                    ภายใน 3-5 วัน
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="urgentRadio"
                      value={"ภายใน 7 วัน"}
                    />{" "}
                    ภายใน 7 วัน
                  </label>

                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="urgentRadio"
                      value={"ภายใน 14 วัน"}
                    />{" "}
                    ภายใน 14 วัน
                  </label>

                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="urgentRadio"
                      value={"ภายใน 30 วัน"}
                    />{" "}
                    ภายใน 30 วัน
                  </label>

                  <label class="radio-inline mt-3">
                    <input
                      type="radio"
                      name="urgentRadio"
                      value={""}
                      checked={urgent == "" ? true : false}
                    />{" "}
                    (ไม่เร่งด่วน)
                  </label>
                </div>
              </div>

              {/* ******** ส่วนของตัวเตือนเปิด Location ********** */}

              <div class="p-3 ">
                <p class="h5 text-start fw-bold mb-3 mt-3">เพิ่มรูปภาพปัญหา</p>
                <div className="d-flex justify-content-center">
                  <div className="img-report">
                    <img src={imgReport} onClick={handleClickUploadImg} />

                    <button
                      class="btn"
                      type="button"
                      onClick={handleClickUploadImg}
                    >
                      เพิ่มรูปภาพ
                    </button>
                    <input
                      type="file"
                      id="file"
                      onChange={onChangePicture}
                      ref={inputFile}
                      accept="image/*"
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>

              <div className="d-grid gap-2 col-6 mx-auto mt-5">
                <button
                  className="btn btn-primary button"
                  // type="submit"
                  onClick={handlefuncFillOTP}
                  disabled={setotpbuttondisabled}
                >
                  แจ้งปัญหา
                </button>
              </div>

              {/* กำลังดำเนินการแจ้งเรื่อง */}
              <div
                className="modal fade"
                ref={modal_loading_ref}
                id="loadingReport"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabindex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content bg-transparent border-0">
                    <div className="modal-body text-center">
                      <div className="d-flex justify-content-center">
                        <span
                          className="spinner-border text-white"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </span>
                        <h4 className="text-white ps-2">กำลังดำเนินการ...</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* กำลังดำเนินการแจ้งเรื่อง */}

              {/* ******* ส่วนของ popup reopen ************* */}
              <div
                class="modal fade"
                ref={modal_fillOTP_ref}
                id="staticBackdrop"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabindex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content ">
                    <div class="modal-body text-secondary d-flex justify-content-end p-2">
                      <span
                        role="button"
                        class="material-icons display-1 align-bottom "
                        onClick={handleModalFillOTPClose}
                      >
                        highlight_off
                      </span>
                    </div>
                    <div class="modal-body text-center p-0">
                      <h4 class="modal-title p-0 fw-bold">
                        กรอกรหัส OTP ที่ได้รับจากข้อความ SMS
                      </h4>
                    </div>

                    <div className="p-3 d-flex">
                      <input
                        required
                        type="tel"
                        pattern="\d{4}"
                        data-bind="value:replyNumber"
                        class="form-control"
                        value={smsOTP}
                        onChange={(e) => setSmsOTP(e.target.value)}
                        placeholder="กรอก OTP"
                      />
                      <div className="ps-3 d-flex">
                        <button
                          className="btn btn-primary button mb-0"
                          type="submit"
                          disabled={disableBtnSendData}
                        >
                          ยืนยัน
                        </button>
                      </div>
                    </div>
                    {showErrorText == true ? (
                      <div class="modal-body text-center p-0">
                        <p class="modal-title p-0 text-danger">
                        กรุณากรอกรหัส OTP ที่ได้จาก SMS
                        </p>
                      </div>
                    ) : null}

                    <p></p>
                  </div>
                </div>
              </div>
              {/* ******* ส่วนของ popup reopen ************* */}

              {/* ******* ส่วนของ Alert ************* */}
              <div
                className="modal fade"
                ref={modal_alert_ref}
                id="stateUpdate"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content bg-transparent border-0">
                    <div className="modal-body text-center">
                      <div className="d-flex justify-content-center">
                        <div className="card post-alert-box rounded-4">
                          <div className="card-body">
                            <p className="card-text p-0 m-0">{alert_content}</p>
                            <h4 className="card-title fs-4 fw-bold">
                              {alert_header}
                            </h4>
                            <h6 className="card-title pb-3" style={{whiteSpace: 'pre-line'}}>
                              {alert_description}
                            </h6>
                            <button
                              type="button"
                              className="btn btn-primary "
                              onClick={handleBtnAlertClose}
                            >
                              ตกลง
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ******* ส่วนของ Alert ************* */}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
